/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BookingProviderRequestResponseItem,
    BookingProviderRequestResponseItemFromJSON,
    BookingProviderRequestResponseItemFromJSONTyped,
    BookingProviderRequestResponseItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingLogsResult
 */
export interface BookingLogsResult {
    /**
     * 
     * @type {string}
     * @memberof BookingLogsResult
     */
    correlationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingLogsResult
     */
    publicApiResponse?: string | null;
    /**
     * 
     * @type {Array<BookingProviderRequestResponseItem>}
     * @memberof BookingLogsResult
     */
    requestResponseData?: Array<BookingProviderRequestResponseItem> | null;
}

export function BookingLogsResultFromJSON(json: any): BookingLogsResult {
    return BookingLogsResultFromJSONTyped(json, false);
}

export function BookingLogsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingLogsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'correlationId': !exists(json, 'correlationId') ? undefined : json['correlationId'],
        'publicApiResponse': !exists(json, 'publicApiResponse') ? undefined : json['publicApiResponse'],
        'requestResponseData': !exists(json, 'requestResponseData') ? undefined : (json['requestResponseData'] === null ? null : (json['requestResponseData'] as Array<any>).map(BookingProviderRequestResponseItemFromJSON)),
    };
}

export function BookingLogsResultToJSON(value?: BookingLogsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'correlationId': value.correlationId,
        'publicApiResponse': value.publicApiResponse,
        'requestResponseData': value.requestResponseData === undefined ? undefined : (value.requestResponseData === null ? null : (value.requestResponseData as Array<any>).map(BookingProviderRequestResponseItemToJSON)),
    };
}


